/* global axios */
// Índice compartilhado conversation_id -> {funnel/stage} para exibir o badge de
// funil/etapa nos itens da lista de conversas (porta o SCRIPT 5 do dashboard
// injetado, agora nativo). Carrega uma vez, cacheia por 60s e é reusado por todos
// os cards.
import { ref, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const index = ref({});
let expiry = 0;
let inFlight = null;

const fetchIndex = async accountId => {
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${accountId}/kanban/cards/index_map`
    );
    index.value = data.data || {};
    expiry = Date.now() + 60000;
  } catch (e) {
    index.value = {};
    expiry = Date.now() + 10000; // erro: tenta de novo logo
  }
};

const ensureLoaded = accountId => {
  if (!accountId) return;
  if (Date.now() < expiry || inFlight) return;
  inFlight = fetchIndex(accountId).finally(() => {
    inFlight = null;
  });
};

export function useKanbanStageBadge() {
  const accountId = useMapGetter('getCurrentAccountId');
  const getAccountFn = useMapGetter('accounts/getAccount');
  const currentAccount = computed(() => getAccountFn.value(accountId.value));

  const isEnabled = () =>
    currentAccount.value?.feature_modules?.kanban !== false;

  const stageFor = conversationId => {
    if (!isEnabled()) return null;
    ensureLoaded(accountId.value);
    return index.value[String(conversationId)] || null;
  };

  // Permite ao board/box invalidar o cache após mover/remover um card.
  const refresh = () => {
    expiry = 0;
    ensureLoaded(accountId.value);
  };

  // Marca o cache como expirado SEM refetch imediato — usado pelo board do Kanban:
  // o índice é rebuscado só quando a lista de conversas voltar a renderizar,
  // evitando requests durante o drag-drop.
  const invalidate = () => {
    expiry = 0;
  };

  // Atualização LOCAL do cache (sem refetch) quando a etapa muda no box/board —
  // mantém a tag do listing em sincronia sem bater no servidor.
  const setStage = (conversationId, info) => {
    if (conversationId == null || !info) return;
    index.value = { ...index.value, [String(conversationId)]: info };
  };
  const clearStage = conversationId => {
    if (conversationId == null) return;
    const next = { ...index.value };
    delete next[String(conversationId)];
    index.value = next;
  };

  return { stageFor, refresh, setStage, clearStage, invalidate };
}
